@if (displayLoading) {
  <div
    class="d-flex flex-column align-items-center justify-content-center common-loading-container"
  >
    <div class="w-25 text-center">
      <img class="common-loading" src="assets/menu_loading.gif" alt="common loading" />
      <p class="common-loading-text">Loading menu details, please wait...</p>
    </div>
  </div>
} @else {
  <div class="row am-row">
    <div class="col-sm-9 am-col">
      <div class="d-flex align-items-start flex-column mr-5 ml-5 am-col-inner">
        <div class="mb-auto w-100 p-2 overflow-y-auto" style="padding-lefty: 5% !important">
          <form
            [formGroup]="productForm"
            (ngSubmit)="onSubmit()"
            [attr.novalidate]="noValidate"
            auto-complete="off"
            class="upload-container"
          >
            <div class="card-form mt-3 w-85">
              <div class="header-card">
                <div class="title-description">
                  <div class="title-basic-details">Basic Details</div>
                  <div class="basic-description">
                    Provide the essential details about the menu item to help customers easily
                    identify it.
                  </div>
                </div>
              </div>
              <div class="row w-100 m-0 p-0" [ngClass]="{ 'disabled-content': isNotFnfHardware }">
                <label class="form-label pl-0"><span class="status-span">*</span>Name:</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  formControlName="name"
                  name="name"
                  [maxlength]="120"
                  [ngClass]="{
                    'input-error':
                      productForm.get('name')?.invalid &&
                      (productForm.get('name')?.touched ||
                        productForm.get('name')?.dirty ||
                        isSubmit),
                  }"
                />
                @if (
                  productForm.get('name')?.errors?.['required'] &&
                  (productForm.get('name')?.touched || productForm.get('name')?.dirty)
                ) {
                  <div class="d-flex mt-2 errorText gap-2 pl-0">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>Name cannot be empty.</p>
                  </div>
                } @else if (productForm.get('name')?.errors?.['minlength']) {
                  <div class="d-flex mt-2 errorText gap-2 pl-0">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>Name should be have 2 characters.</p>
                  </div>
                } @else if (productForm.get('name')?.errors?.['maxlength']) {
                  <div class="d-flex mt-2 errorText gap-2 pl-0">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>Name can not exceed 120 characters.</p>
                  </div>
                } @else if (productForm.get('name')?.errors?.['numbersOnly']) {
                  <div class="d-flex mt-2 errorText gap-2 pl-0">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>Name cannot be numbers only.</p>
                  </div>
                } @else if (productForm.get('name')?.invalid && isSubmit) {
                  <div class="d-flex mt-2 errorText gap-2 pl-0">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>Name cannot be empty.</p>
                  </div>
                }
                <div class="info-panel pl-0 mt-2 pr-0">
                  <div class="help-text">Include keywords people might search for.</div>
                  <div class="counter">
                    <span>
                      <span class="counter-start">
                        {{
                          productForm.get('name')?.value
                            ? productForm.get('name')?.value?.length
                            : 0
                        }}
                      </span>
                      <span class="counter-end">/120</span>
                    </span>
                  </div>
                </div>
              </div>

              <div class="row w-100 m-0 p-0 mt-1">
                <div class="d-flex m-0 p-0">
                  <div class="flex-grow-1">
                    <label class="form-label pl-0 pt-2"
                      ><span class="status-span">*</span>Description:</label
                    >
                  </div>
                  <div
                    class="p-2"
                    matTooltip="Before click It enter the Menu name."
                    matTooltipPosition="right"
                  >
                    <app-ai-generate-button
                      [loading]="generating.description"
                      [disabled]="!productForm.get('name')?.value?.trim()"
                      (generate)="getMenuDescriptions()"
                    ></app-ai-generate-button>
                  </div>
                </div>

                <textarea
                  class="form-control"
                  rows="3"
                  name="description"
                  formControlName="description"
                  [maxlength]="200"
                  [ngClass]="{
                    'input-error':
                      productForm.get('description')?.invalid &&
                      (productForm.get('description')?.touched ||
                        productForm.get('description')?.dirty ||
                        isSubmit) &&
                      selectedStatus == 'published',
                  }"
                ></textarea>
                @if (
                  (productForm.get('description')?.errors?.['required'] &&
                    productForm.get('description')?.touched) ||
                  (productForm.get('description')?.errors?.['required'] &&
                    (productForm.get('description')?.touched ||
                      productForm.get('description')?.dirty ||
                      isSubmit) &&
                    selectedStatus == 'published')
                ) {
                  <div class="d-flex mt-2 errorText gap-2 pl-0">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>Description cannot be empty.</p>
                  </div>
                } @else if (productForm.get('description')?.value.length > 200) {
                  <div class="d-flex mt-2 errorText gap-2 pl-0">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>Exceed the description limit.</p>
                  </div>
                }
                <div class="info-panel pl-0 mt-2 pr-0">
                  <div class="help-text">Provide a short, engaging description of the item.</div>
                  <div class="counter">
                    <span>
                      <span class="counter-start"
                        >{{ productForm.get('description')?.value.length }}
                      </span>
                      <span class="counter-end">/200</span>
                    </span>
                  </div>
                </div>
              </div>

              <div class="row w-100 m-0 p-0">
                <!-- <label class="form-label pl-0">Cover Image:</label> -->
                <div class="d-flex m-0 p-0">
                  <div class="flex-grow-1">
                    <label class="form-label pl-0 pt-2">Cover Image:</label>
                  </div>
                  @if (exitingMenuId && exitingMenuId != '' && exitingMenuId != null) {
                    <div
                      class="pr-2"
                      matTooltip="Generate cover image using AI"
                      matTooltipPosition="right"
                    >
                      <app-ai-generate-button
                        [loading]="generating.image"
                        [disabled]="!productForm.get('name')?.value?.trim()"
                        (generate)="generateMenuCoverImage()"
                      ></app-ai-generate-button>
                    </div>
                  }
                </div>
                <div class="help-text p-0">
                  Upload a high-quality image that best represents the item.
                </div>
                <div class="img-upload-container text-center mt-2">
                  <label for="fileUpload" class="upload-box">
                    @if (!imagePreview && !productForm.get('image_url')?.value) {
                      <div class="upload-instruction">
                        <!-- <p>Drag & Drop or</p> -->
                        <div class="btn-browse d-flex gap-2 align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M9.33325 3.99992H14.6666M11.9999 6.66658V1.33325"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                            <path
                              d="M7.66659 2C4.68103 2 3.18825 2 2.26075 2.92749C1.33325 3.85499 1.33325 5.34777 1.33325 8.33333C1.33325 11.3189 1.33325 12.8117 2.26075 13.7392C3.18825 14.6667 4.68103 14.6667 7.66659 14.6667C10.6521 14.6667 12.1449 14.6667 13.0725 13.7392C13.9999 12.8117 13.9999 11.3189 13.9999 8.33333V8"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                            <path
                              d="M1.33325 9.42351C1.74593 9.36357 2.16315 9.33397 2.58106 9.33504C4.34902 9.29764 6.07368 9.84851 7.44732 10.8894C8.72125 11.8546 9.61639 13.1832 9.99992 14.6666"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M14 11.2642C13.2164 10.8673 12.4059 10.6659 11.5908 10.6668C10.3563 10.6619 9.13433 11.1156 8 12.0001"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span>Browse to Add</span>
                        </div>
                      </div>
                    }

                    @if (productForm.get('image_url')?.value) {
                      <img
                        [class.image-error]="hasImageError(productForm.get('image_url')?.value)"
                        [src]="productForm.get('image_url')?.value"
                        alt="Image Preview"
                        class="image-preview"
                        (error)="
                          onMenuThumbnailImageError($event, productForm.get('image_url')?.value)
                        "
                      />
                      <button
                        type="button"
                        class="remove-img-btn btn bg-white btn-sm rounded-5"
                        (click)="removeImage()"
                      >
                        <i class="bx bx-trash text-danger"></i>
                      </button>
                    } @else if (imagePreview) {
                      <img
                        [class.image-error]="hasImageError(imagePreview)"
                        [src]="imagePreview"
                        alt="Image Preview"
                        class="image-preview"
                        (error)="onMenuThumbnailImageError($event, imagePreview)"
                      />
                      <button
                        type="button"
                        class="remove-img-btn btn bg-white btn-sm rounded-5"
                        (click)="removeImage()"
                      >
                        <i class="bx bx-trash text-danger"></i>
                      </button>
                    }
                    <input
                      type="file"
                      id="fileUpload"
                      (change)="onFileSelected($event)"
                      class="file-input"
                      accept=".jpg, .jpeg, .png, .gif, .webp"
                      formControlName="coverImage"
                    />
                  </label>
                </div>
                <!-- @if(productForm.get('coverImage')?.value == null && productForm.get('coverImage')?.touched){
                <div class="d-flex mt-2 errorText gap-2 pl-0">
                  <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                  <p  >Cover Image cannot be empty.</p>
                </div>
              } -->
                @if (coverImageSizeError) {
                  <div class="d-flex mt-2 errorText gap-2 pl-0">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>{{ coverImageSizeError }}</p>
                  </div>
                }
                <!-- <p>Image upload</p> -->
                <div class="info-panel pl-0 mt-2 pr-0">
                  <div class="help-text">Allowed formats: JPG, PNG, JPEG, WEBP, GIF</div>
                  <div class="counter">
                    <span>
                      <span class="counter-end">Max size: 10MB</span>
                    </span>
                  </div>
                </div>
              </div>

              <div class="row w-100 m-0 p-0">
                <label class="form-label pl-0">Additional Images(Optional):</label>
                <div class="help-text p-0">
                  You may add more images to show different angles or close-ups of the item.
                </div>
                <!-- <p>Image upload</p> -->

                <div
                  class="img-upload-container text-center mt-2"
                  formArrayName="additional_images"
                >
                  <label for="additional-images-upload" class="upload-box">
                    @if (
                      !(images && images.length > 0) &&
                      productForm.get('additional_images')?.value.length == 0
                    ) {
                      <div class="upload-instruction">
                        <!-- <p>Drag & Drop or</p> -->
                        <div class="btn-browse1 d-flex gap-2 align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M9.33325 3.99992H14.6666M11.9999 6.66658V1.33325"
                              stroke="currentColor"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                            <path
                              d="M7.66659 2C4.68103 2 3.18825 2 2.26075 2.92749C1.33325 3.85499 1.33325 5.34777 1.33325 8.33333C1.33325 11.3189 1.33325 12.8117 2.26075 13.7392C3.18825 14.6667 4.68103 14.6667 7.66659 14.6667C10.6521 14.6667 12.1449 14.6667 13.0725 13.7392C13.9999 12.8117 13.9999 11.3189 13.9999 8.33333V8"
                              stroke="currentColor"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                            <path
                              d="M1.33325 9.42351C1.74593 9.36357 2.16315 9.33397 2.58106 9.33504C4.34902 9.29764 6.07368 9.84851 7.44732 10.8894C8.72125 11.8546 9.61639 13.1832 9.99992 14.6666"
                              stroke="currentColor"
                              stroke-width="1.5"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M14 11.2642C13.2164 10.8673 12.4059 10.6659 11.5908 10.6668C10.3563 10.6619 9.13433 11.1156 8 12.0001"
                              stroke="currentColor"
                              stroke-width="1.5"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span>Add up to 4 photos</span>
                        </div>
                      </div>
                    }
                    @if (images && images.length > 0) {
                      @for (img of images; track img; let i = $index) {
                        <div class="preview-item">
                          <img
                            [class.image-error]="hasImageError(img.url)"
                            [src]="img.url"
                            [alt]="'Image ' + (i + 1)"
                            class="image-preview1"
                            (error)="onMenuThumbnailImageError($event, img.url)"
                          />
                          <button
                            type="button"
                            class="btn remove-img-btn btn-sm btn-outline-danger bg-white rounded-5"
                            (click)="removeAdditionalImage(i)"
                          >
                            <i class="bx bx-trash text-danger"></i>
                          </button>
                        </div>
                      }
                    } @else if (productForm.get('additional_images')?.value?.length > 0) {
                      @for (
                        img of productForm.get('additional_images')?.value;
                        track img;
                        let i = $index
                      ) {
                        <div class="preview-item">
                          <img
                            [class.image-error]="hasImageError(img)"
                            [src]="img"
                            [alt]="'Image ' + (i + 1)"
                            class="image-preview1"
                            (error)="onMenuThumbnailImageError($event, img)"
                          />
                          <button
                            type="button"
                            class="btn remove-img-btn btn-sm btn-outline-danger bg-white rounded-5"
                            (click)="removeAdditionalImage(i)"
                          >
                            <i class="bx bx-trash text-danger"></i>
                          </button>
                        </div>
                      }
                    }

                    <input
                      type="file"
                      id="additional-images-upload"
                      (change)="onFilesSelected($event)"
                      multiple
                      class="file-input1"
                      accept=".jpg,.jpeg,.png,.webp,.gif"
                      [disabled]="images.length >= 4"
                    />
                  </label>
                  @if (additionalImageSizeError) {
                    <div class="d-flex mt-2 errorText gap-2 pl-0">
                      <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                      <p>{{ additionalImageSizeError }}</p>
                    </div>
                  }
                </div>

                <div class="info-panel pl-0 mt-2 pr-0">
                  <div class="help-text">Allowed formats: JPG, PNG, JPEG, WEBP, GIF</div>
                  <div class="counter">
                    <span>
                      <span class="counter-end">Max size: 10MB each</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-form mt-4 w-85">
              <div class="header-card">
                <div class="title-description">
                  <div class="title-basic-details">Pricing &amp; Inventory</div>
                  <div class="basic-description">
                    Set the price, stock status, and SKU for this item.
                  </div>
                </div>
              </div>
              <div class="row w-100 m-0 p-0">
                <div
                  class="col-4 m-0 pl-0 pr-5 me-1"
                  [ngClass]="{
                    'disabled-content': isNotFnfHardware,
                    'cursor-not-allowed': isNotFnfHardware,
                  }"
                >
                  <label class="form-label pl-0"><span class="status-span">*</span>Price:</label>
                  <div class="input-group">
                    <span class="input-group-text bg-white border-top border-bottom border-left"
                      >$</span
                    >
                    <input
                      type="number"
                      class="form-control border-left-0"
                      formControlName="originalPrice"
                      min="0"
                      name="originalPrice"
                      (keydown)="preventNegativeInput($event)"
                    />
                  </div>
                  <!-- <input type="number" class="form-control" formControlName="originalPrice" min="0" name="originalPrice"
                (keydown)="preventNegativeInput($event)"> -->
                  @if (
                    productForm.get('originalPrice')?.invalid &&
                    productForm.get('originalPrice')?.touched
                  ) {
                    <div class="d-flex mt-2 errorText gap-2">
                      <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                      <p>Original price cannot be empty.</p>
                    </div>
                  }
                  <div class="help-text p-0 pt-2">Enter the regular price.</div>
                </div>
                <div class="col-4 m-0 pl-0 pr-5 me-1">
                  <label class="form-label pl-0">SKU:</label>
                  <input type="text" class="form-control" formControlName="sku" />
                  @if (
                    productForm.get('sku')?.value?.length == 0 &&
                    productForm.get('sku')?.touched &&
                    false
                  ) {
                    <div class="d-flex mt-2 errorText gap-2">
                      <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                      <p>SKU cannot be empty.</p>
                    </div>
                  } @else if (productForm.get('sku')?.hasError('invalidSku')) {
                    <div class="d-flex mt-2 errorText gap-2">
                      <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                      <p>SKU must start with 2 letters followed by 3 numbers (e.g., AB123).</p>
                    </div>
                  } @else if (productForm.get('sku')?.hasError('invalidExistingSku')) {
                    <div class="d-flex mt-2 errorText gap-2">
                      <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                      <p>Entered SKU already exit in our system.</p>
                    </div>
                  } @else if (
                    productForm.get('sku')?.hasError('minlength') && productForm.get('sku')?.touched
                  ) {
                    <div class="d-flex mt-2 errorText gap-2">
                      <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                      <p>SKU must be exactly 5 characters long.</p>
                    </div>
                  } @else if (productForm.get('sku')?.touched && exitingSKUMsg) {
                    <div class="d-flex mt-2 errorText gap-2">
                      <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                      <p>{{ exitingSKUMsg }}</p>
                    </div>
                  }
                  <div class="help-text p-0 pt-2">Unique ID for the item.</div>
                </div>
                <div
                  class="col-4 m-0 pl-0 ms-1"
                  [ngClass]="{ 'disabled-content': isNotFnfHardware }"
                >
                  <label class="form-label pl-0">Stock status:</label>
                  <div class="form-check form-switch ml-0 stock-form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked
                      formControlName="stockStatus"
                    />
                    @if (productForm.get('stockStatus')?.value) {
                      <label class="form-check-label ms-4 pt-2 text-success">In-stock</label>
                    } @else {
                      <label class="form-check-label ms-4 pt-2 text-danger">Out of stock</label>
                    }
                  </div>
                  <div class="help-text p-0 pt-2">
                    Choose if the item is in stock or out of stock.
                  </div>
                  @if (!hasMultipleSquareVariations && squareVariationStocks.length === 1) {
                    <div class="help-text p-0 pt-2">
                      Stock count: <strong>{{ squareVariationStocks[0].stockCount }}</strong>
                    </div>
                  } @else if (hasMultipleSquareVariations && squareVariationStocks.length > 0) {
                    <div class="stock-variation-list mt-2">
                      @for (v of squareVariationStocks; track v.name) {
                        <div class="stock-variation-row">
                          <span class="stock-variation-name" [title]="v.name">{{ v.name }}</span>
                          <span class="stock-badge" [ngClass]="stockBadgeClass(v.stockCount)">
                            {{ stockBadgeLabel(v.stockCount) }}
                          </span>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>

            <div
              class="card-form mt-4 w-85"
              [ngClass]="{ 'input-error': !isAnyCategorySelected && isSubmit }"
            >
              <div class="d-flex w-100">
                <div class="flex-grow-1">
                  <div class="header-card">
                    <div class="title-description">
                      <div class="title-basic-details">Classification</div>
                      <div class="basic-description">
                        Categorize the item to help organize the menu.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-2">
                  <button
                    class="btn btn-dark"
                    type="button"
                    (click)="addNewClassification()"
                    [ngClass]="{ 'disabled-content': isNotFnfHardware }"
                  >
                    <i class="bx bx-plus"></i> Add New Type
                  </button>
                </div>
              </div>

              <div
                formArrayName="classification"
                [ngClass]="{ 'disabled-content': isNotFnfHardware }"
              >
                @for (
                  subClassification of classification.controls;
                  track subClassification;
                  let i = $index
                ) {
                  <div
                    class="row w-100 m-0 p-0 mt-2"
                    [formGroupName]="i"
                    [ngClass]="{
                      'disabled-content': subClassification.get('name')?.value == 'Uber',
                    }"
                  >
                    <label class="form-label pl-0">
                      @if (subClassification.get('isMandatory')?.value) {
                        <span class="status-span">*</span>
                      }
                      {{ subClassification.get('name')?.value }}:
                    </label>
                    @if (subClassification.get('isMultiSelect')?.value) {
                      <div class="row m-0 p-0 d-flex flex-wrap gap-1 gy-2" formArrayName="options">
                        @for (
                          option of getOption(subClassification).controls;
                          track option;
                          let j = $index
                        ) {
                          @if (option.get('name')?.value) {
                            <div
                              class="form-check classification-chip p-2 border-0 pl-4 w-auto bg-light mr-2"
                              [formGroupName]="j"
                              [ngClass]="{ 'highlight-primary': option.get('isChecked')?.value }"
                            >
                              <input
                                class="form-check-input pl-2 classification-multi-form-check"
                                type="checkbox"
                                [checked]="option.get('isChecked')?.value"
                                [value]="option"
                                [name]="option.get('name')?.value"
                                [value]="option.get('name')?.value"
                                (change)="
                                  onMultiClassificationChange(
                                    $event,
                                    subClassification,
                                    option,
                                    i,
                                    j
                                  )
                                "
                                (click)="$event.stopPropagation()"
                              />

                              <label
                                class="form-check-label"
                                [ngClass]="{ 'text-primary': option.get('isChecked')?.value }"
                              >
                                {{ option.get('name')?.value }}
                              </label>
                            </div>
                          }
                        }
                        <button
                          type="button"
                          class="btn btn-white common-add-btn text-black-50 w-auto dashed-border-button"
                          (click)="addCategory(subClassification)"
                          [ngClass]="{ 'disabled-content': isNotFnfHardware }"
                        >
                          + Add Category
                        </button>
                      </div>
                    } @else {
                      <div class="row m-0 p-0 d-flex flex-wrap gap-1 gy-2" formArrayName="options">
                        @for (
                          option of getOption(subClassification).controls;
                          track option;
                          let j = $index
                        ) {
                          @if (option.get('name')?.value) {
                            <div
                              class="form-check classification-chip p-2 border-0 pl-4 w-auto bg-light mr-2"
                              [formGroupName]="j"
                              [ngClass]="{ 'highlight-primary': option.get('isChecked')?.value }"
                            >
                              <input
                                class="form-check-input classification-single-form-check"
                                type="radio"
                                [name]="subClassification.get('name')?.value"
                                (change)="
                                  onSingleClassificationChange(
                                    $event,
                                    subClassification,
                                    option,
                                    i,
                                    j
                                  )
                                "
                                [id]="subClassification.get('name')?.value"
                                [value]="option.get('name')?.value"
                                [checked]="option.get('isChecked')?.value"
                              />
                              <label
                                class="form-check-label"
                                [ngClass]="{ 'text-primary': option.get('isChecked')?.value }"
                              >
                                {{ option.get('name')?.value }}
                              </label>
                            </div>
                          }
                        }
                        <button
                          type="button"
                          class="btn btn-white common-add-btn text-black-50 w-auto dashed-border-button"
                          (click)="addCategory(subClassification)"
                          [ngClass]="{ 'disabled-content': isNotFnfHardware }"
                        >
                          + Add Category
                        </button>
                      </div>
                    }
                  </div>
                  @if (
                    subClassification.get('isMandatory')?.value &&
                    subClassification.hasError('mandatoryClassificationRequired') &&
                    (subClassification.touched || subClassification.dirty)
                  ) {
                    <div class="d-flex mt-2 errorText gap-2">
                      <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                      <p>This field cannot be empty.</p>
                    </div>
                  }
                }
              </div>
            </div>

            <div class="card-form mt-4 w-85">
              <div class="header-card">
                <div class="title-description">
                  <div class="title-basic-details">Ingredients, Preparation &amp; Serving</div>
                  <div class="basic-description">
                    Provide details about the ingredients, preparation time, and serving
                    information.
                  </div>
                </div>
              </div>
              <div class="row w-100 m-0 p-0">
                <div class="d-flex justify-content-between pl-0 pr-0 mb-2">
                  <label class="form-label pl-0 pt-2">Station: </label>
                </div>
                <div class="pl-0 pr-0">
                  <button
                    class="btn dropdown-toggle bg-white form-control border text-left rounded-2"
                    type="button"
                    id="dropdownMenuButton2"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {{
                      selectedStation
                        ? (selectedStation.station_name | titlecase)
                        : 'Select Station'
                    }}
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                    <li
                      (click)="createNewStation()"
                      [ngClass]="{ 'disabled-content': isNotFnfHardware }"
                    >
                      <a class="dropdown-item"><span class="bx bx-plus pr-2"></span>New Station</a>
                    </li>
                    @for (station of stations; track station; let i = $index) {
                      <li (click)="changeStation(station)">
                        <a class="dropdown-item"
                          ><span class="bx bx-pin pr-2"></span
                          >{{ station.station_name | titlecase }}</a
                        >
                      </li>
                    }
                  </ul>
                </div>
                <div class="info-panel pl-0 mt-2 pr-0">
                  <div class="help-text">Select your station to connect the printers.</div>
                </div>
              </div>
              <div class="row w-100 m-0 p-0">
                <div class="d-flex m-0 p-0">
                  <div class="flex-grow-1">
                    <label class="form-label pl-0 pt-2"
                      ><span class="status-span">*</span>Menu Order Type:</label
                    >
                  </div>
                </div>
                <!-- I want to display the menu order tpye multi selection here -->

                <div formGroupName="orderTypes" class="row m-0 p-0 d-flex flex-wrap gap-2">
                  <div
                    class="form-check classification-chip p-2 border-0 pl-4 w-auto bg-light mr-2"
                    [ngClass]="{
                      'highlight-primary': productForm.get('orderTypes.is_dine_in')?.value,
                    }"
                  >
                    <input
                      class="form-check-input pl-2 classification-multi-form-check"
                      type="checkbox"
                      formControlName="is_dine_in"
                      id="order_dine_in"
                      (change)="onOrderTypeChange('is_dine_in')"
                    />
                    <label
                      class="form-check-label"
                      for="order_dine_in"
                      [ngClass]="{
                        'text-primary': productForm.get('orderTypes.is_dine_in')?.value,
                      }"
                    >
                      Dine In
                    </label>
                  </div>

                  <div
                    class="form-check classification-chip p-2 border-0 pl-4 w-auto bg-light mr-2"
                    [ngClass]="{
                      'highlight-primary': productForm.get('orderTypes.is_togo')?.value,
                    }"
                  >
                    <input
                      class="form-check-input pl-2 classification-multi-form-check"
                      type="checkbox"
                      formControlName="is_togo"
                      id="order_togo"
                      (change)="onOrderTypeChange('is_togo')"
                    />
                    <label
                      class="form-check-label"
                      for="order_togo"
                      [ngClass]="{ 'text-primary': productForm.get('orderTypes.is_togo')?.value }"
                    >
                      Togo
                    </label>
                  </div>

                  <div
                    class="form-check classification-chip p-2 border-0 pl-4 w-auto bg-light mr-2"
                    [ngClass]="{
                      'highlight-primary': productForm.get('orderTypes.is_catering')?.value,
                    }"
                  >
                    <input
                      class="form-check-input pl-2 classification-multi-form-check"
                      type="checkbox"
                      formControlName="is_catering"
                      id="order_catering"
                      (change)="onOrderTypeChange('is_catering')"
                    />
                    <label
                      class="form-check-label"
                      for="order_catering"
                      [ngClass]="{
                        'text-primary': productForm.get('orderTypes.is_catering')?.value,
                      }"
                    >
                      Catering
                    </label>
                  </div>
                </div>

                <div class="info-panel pl-0 mt-2 pr-0">
                  <div class="help-text">Select how this item can be ordered.</div>
                </div>

                @if (orderTypes.hasError('atLeastOneRequired') && isSubmit) {
                  <div class="text-danger mt-2" style="font-size: 0.8rem">
                    Please select at least one order type.
                  </div>
                }
              </div>
              <div class="row w-100 m-0 p-0 d-none">
                <!-- <div class="d-flex justify-content-between pl-0 pr-0 mb-2">
                    <label class="form-label pl-0 pt-2"><span class="status-span">*</span>Serving Time: </label>
                  <button class="btn btn-dark" type="button" (click)="addNewServingTime()"  > + New serving time</button>
                </div>
                <select class="form-select" formControlName="servingTime" >
                    <option value="0" selected disabled>Select serving time</option>  
                      @for (time of servingTimes; track time; let i = $index) {
                      <option [value]="time.id">{{time.name}} ( {{time.start_time}} - {{time.end_time}} )</option>
                      }
                </select>
                <div class="info-panel pl-0 mt-2 pr-0">
                  <div class="help-text">
                    Select your menu serving time information.
                  </div>
                </div>
                @if ( this.productForm.get('servingTime')?.value == 0 && (productForm.get('servingTime')?.dirty || productForm.get('servingTime')?.touched)) {
                  <div class="d-flex mt-2 errorText gap-2 pl-0">
                      <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                      <p>Serving time can not be empty.</p>
                  </div>
                } -->
              </div>
              <div class="row w-100 m-0 p-0 mt-1">
                <div class="d-flex m-0 p-0">
                  <div class="flex-grow-1">
                    <label class="form-label pl-0 pt-2">Ingredients:</label>
                  </div>
                  <div
                    class="p-2"
                    matTooltip="Before click It enter the Menu name."
                    matTooltipPosition="right"
                  >
                    <app-ai-generate-button
                      [loading]="generating.ingredients"
                      [disabled]="!productForm.get('name')?.value?.trim()"
                      (generate)="getMenuIngredients()"
                    ></app-ai-generate-button>
                  </div>
                </div>

                <div class="w-100 p-0">
                  <div class="ingredients-input-group">
                    @for (ingredient of menuIngredients; track ingredient; let idx = $index) {
                      <div class="ingredient-tag">
                        {{ ingredient | titlecase }}
                        <button type="button" class="remove-btn" (click)="removeIngredient(idx)">
                          ×
                        </button>
                      </div>
                    }
                    <input
                      id="ingredient-input"
                      type="text"
                      class="ingredient-input"
                      formControlName="ingredientName"
                      placeholder="Enter ingredients (e.g., mozzarella, tomato, basil)..."
                      (keydown.enter)="addIngredient()"
                    />
                  </div>
                </div>

                @if (
                  productForm.get('ingredientName')?.touched && menuIngredients.length < 1 && false
                ) {
                  <div class="d-flex mt-2 errorText gap-2 pl-0">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>This field cannot be empty.</p>
                  </div>
                } @else if (menuIngredients.length > 12) {
                  <div class="d-flex mt-2 errorText gap-2 pl-0">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>Exceed the ingredients count limit.</p>
                  </div>
                }

                <div class="info-panel pl-0 mt-2 pr-0">
                  <div class="help-text">
                    Buyers value transparency—tell them what's used to make your item.
                  </div>
                  <div class="counter">
                    <span>
                      <span class="counter-start">{{ menuIngredients.length }}</span>
                      <span class="counter-end">/12</span>
                    </span>
                  </div>
                </div>
              </div>

              <div class="row w-100 m-0 p-0">
                <div class="col-5 m-0 p-0 me-1">
                  <div class="d-flex align-items-center justify-content-between">
                    <label class="form-label pl-0"
                      ><span class="status-span">*</span>Preparation Time:</label
                    >
                    <div
                      class="pb-1"
                      matTooltip="Enter the menu name before generating."
                      matTooltipPosition="right"
                    >
                      <app-ai-generate-button
                        [loading]="generating.prepTime"
                        [disabled]="!productForm.get('name')?.value?.trim()"
                        (generate)="getMenuPreparationTime()"
                      ></app-ai-generate-button>
                    </div>
                  </div>
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control border-right-0"
                      formControlName="preparationTime"
                      min="5"
                      (keydown)="preventNegativeInput($event)"
                    />
                    <span
                      class="preparation-group-text bg-white border-top border-bottom border-left"
                    >
                      Minutes
                    </span>
                  </div>

                  @if (
                    productForm.get('preparationTime')?.invalid &&
                    productForm.get('preparationTime')?.touched
                  ) {
                    <div class="d-flex mt-2 errorText gap-2">
                      <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                      <p>This field cannot be empty.</p>
                    </div>
                  }
                  <div class="help-text p-0 pt-2">Indicate how long it takes to prepare.</div>
                </div>
                <div class="col-2"></div>
                <div
                  class="col-5 m-0 p-0 ms-1"
                  [ngClass]="{
                    'disabled-content': isNotFnfHardware,
                    'cursor-not-allowed': isNotFnfHardware,
                  }"
                >
                  <label class="form-label pl-0"
                    ><span class="status-span">*</span>Serving Size:</label
                  >
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control border-right-0"
                      formControlName="servingSize"
                      min="1"
                      (keydown)="preventNegativeInput($event)"
                    />
                    <span
                      class="preparation-group-text bg-white border-top border-bottom border-left"
                    >
                      Serves
                    </span>
                  </div>

                  @if (
                    productForm.get('servingSize')?.invalid &&
                    productForm.get('servingSize')?.touched
                  ) {
                    <div class="d-flex mt-2 errorText gap-2">
                      <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                      <p>This field cannot be empty.</p>
                    </div>
                  }
                  <div class="help-text p-0 pt-2">Specify serving size or portions.</div>
                </div>
              </div>
              <div class="row w-100 m-0 p-0">
                <label class="form-label pl-0"> Serving Time: </label>
                <div
                  class="w-100 p-0"
                  [formGroup]="servingTimeForm"
                  [ngClass]="{ 'disabled-content': isNotFnfHardware }"
                >
                  <div class="serving-time-table">
                    <div class="serving-time-header-row">
                      <div class="serving-time-col-day">Days</div>
                      <div class="serving-time-col-time">Start time</div>
                      <div class="serving-time-col-time">End time</div>
                    </div>
                    @for (day of servingTimeDays; track day.key) {
                      <div class="serving-time-row" [formGroupName]="day.key">
                        <div class="serving-time-day-column">
                          <label
                            class="serving-time-day-checkbox-label"
                            [class.disabled]="!isServingTimeDayAllowed(day.key)"
                            [matTooltip]="
                              !isServingTimeDayAllowed(day.key)
                                ? 'Restaurant is closed on this day'
                                : ''
                            "
                          >
                            <input
                              type="checkbox"
                              class="serving-time-day-checkbox"
                              [checked]="isServingTimeDayEnabled(day.key)"
                              [disabled]="!isServingTimeDayAllowed(day.key)"
                              (change)="toggleServingTimeDay(day.key)"
                            />
                            <span
                              class="serving-time-day-checkbox-custom"
                              [class.checked]="isServingTimeDayEnabled(day.key)"
                              [class.disabled]="!isServingTimeDayAllowed(day.key)"
                            >
                              @if (isServingTimeDayEnabled(day.key)) {
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="12"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                >
                                  <path
                                    d="M10 3L4.5 8.5L2 6"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              }
                            </span>
                            <span
                              class="serving-time-day-label"
                              [class.disabled]="!isServingTimeDayAllowed(day.key)"
                              >{{ day.label }}</span
                            >
                          </label>
                          <div class="serving-time-restaurant-hours">
                            @if (getRestaurantHoursForDay(day.key).length) {
                              @for (rh of getRestaurantHoursForDay(day.key); track $index) {
                                <span class="serving-time-restaurant-hours-range"
                                  >{{ convertTo12HourFormat(rh.start_time) }} -
                                  {{ convertTo12HourFormat(rh.end_time) }}</span
                                >
                              }
                            } @else {
                              <!-- <span class="serving-time-restaurant-hours-closed"
                              >Restaurant hours not update.</span
                            > -->
                            }
                          </div>
                        </div>

                        <div class="serving-time-hours-list" formArrayName="hours">
                          @if (!isServingTimeDayEnabled(day.key)) {
                            <div class="serving-time-hour-row">
                              <input
                                type="text"
                                class="serving-time-time-input serving-time-closed"
                                value="Closed"
                                disabled
                              />
                              <input
                                type="text"
                                class="serving-time-time-input serving-time-closed"
                                value="Closed"
                                disabled
                              />
                            </div>
                          } @else {
                            @for (
                              hour of getServingTimeHours(day.key).controls;
                              track hour;
                              let hourIndex = $index
                            ) {
                              <div
                                class="serving-time-hour-row"
                                [class.serving-time-hour-row--next-day]="
                                  isServingTimeNextDay(day.key, hourIndex, 'start') ||
                                  isServingTimeNextDay(day.key, hourIndex, 'end')
                                "
                                [formGroupName]="hourIndex"
                              >
                                <div class="serving-time-dropdown-wrapper dropdown">
                                  <button
                                    type="button"
                                    class="btn dropdown-toggle bg-white form-control border text-start rounded-2 serving-time-time-input"
                                    [class.text-black-50]="
                                      getServingTimeDisplay(day.key, hourIndex, 'start') ===
                                      'Select time'
                                    "
                                    [id]="'servingStartTime_' + day.key + '_' + hourIndex"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    {{ getServingTimeDisplay(day.key, hourIndex, 'start') }}
                                  </button>
                                  @if (isServingTimeNextDay(day.key, hourIndex, 'start')) {
                                    <span class="serving-time-next-day-label">Next day</span>
                                  }
                                  <ul
                                    class="dropdown-menu"
                                    [attr.aria-labelledby]="
                                      'servingStartTime_' + day.key + '_' + hourIndex
                                    "
                                  >
                                    @for (
                                      timeItem of getServingStartTimeItems(day.key, hourIndex);
                                      track $index
                                    ) {
                                      @if (timeItem.disabled) {
                                        <li class="serving-time-dropdown-blocked">
                                          <span class="dropdown-item disabled">{{
                                            timeItem.display
                                          }}</span>
                                        </li>
                                      } @else {
                                        <li
                                          (click)="
                                            selectServingTime(
                                              day.key,
                                              hourIndex,
                                              'start',
                                              $any(timeItem.value)
                                            )
                                          "
                                        >
                                          <a class="dropdown-item">{{ timeItem.display }}</a>
                                        </li>
                                      }
                                    }
                                  </ul>
                                </div>
                                <div class="serving-time-dropdown-wrapper dropdown">
                                  <button
                                    type="button"
                                    class="btn dropdown-toggle bg-white form-control border text-start rounded-2 serving-time-time-input"
                                    [class.text-black-50]="
                                      getServingTimeDisplay(day.key, hourIndex, 'end') ===
                                      'Select time'
                                    "
                                    [id]="'servingEndTime_' + day.key + '_' + hourIndex"
                                    [attr.data-bs-toggle]="
                                      canSelectServingEndTime(day.key, hourIndex)
                                        ? 'dropdown'
                                        : null
                                    "
                                    [disabled]="!canSelectServingEndTime(day.key, hourIndex)"
                                    aria-expanded="false"
                                  >
                                    {{ getServingTimeDisplay(day.key, hourIndex, 'end') }}
                                  </button>
                                  @if (isServingTimeNextDay(day.key, hourIndex, 'end')) {
                                    <span class="serving-time-next-day-label">Next day</span>
                                  }
                                  <ul
                                    class="dropdown-menu"
                                    [attr.aria-labelledby]="
                                      'servingEndTime_' + day.key + '_' + hourIndex
                                    "
                                  >
                                    @for (
                                      timeItem of getServingEndTimeItems(day.key, hourIndex);
                                      track $index
                                    ) {
                                      @if (timeItem.disabled) {
                                        <li class="serving-time-dropdown-blocked">
                                          <span class="dropdown-item disabled">{{
                                            timeItem.display
                                          }}</span>
                                        </li>
                                      } @else {
                                        <li
                                          (click)="
                                            selectServingTime(
                                              day.key,
                                              hourIndex,
                                              'end',
                                              $any(timeItem.value)
                                            )
                                          "
                                        >
                                          <a class="dropdown-item">{{ timeItem.display }}</a>
                                        </li>
                                      }
                                    }
                                  </ul>
                                </div>
                                <button
                                  type="button"
                                  class="serving-time-btn-remove-hour"
                                  [disabled]="!canRemoveServingTimeHour(day.key)"
                                  [matTooltip]="
                                    !canRemoveServingTimeHour(day.key)
                                      ? 'At least one time slot is required'
                                      : ''
                                  "
                                  (click)="removeServingTimeHour(day.key, hourIndex)"
                                >
                                  <span class="bx bx-trash"></span>
                                </button>
                              </div>
                              @if (hasServingTimeDuplicateError(day.key, hourIndex)) {
                                <div class="d-flex mt-2 errorText gap-2">
                                  <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                                  <p>This time slot duplicates another one for {{ day.label }}.</p>
                                </div>
                              }
                              @if (hasServingTimeOverlapError(day.key, hourIndex)) {
                                <div class="d-flex mt-2 errorText gap-2">
                                  <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                                  <p>
                                    This time slot overlaps with another one for {{ day.label }}.
                                  </p>
                                </div>
                              }
                              @if (hasServingTimeRangeError(day.key, hourIndex)) {
                                <div class="d-flex mt-2 errorText gap-2">
                                  <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                                  <p>End time must be different from start time.</p>
                                </div>
                              }
                              @if (
                                getServingTimePreviousDayOverlap(day.key, hourIndex);
                                as overlap
                              ) {
                                <div class="d-flex mt-2 errorText gap-2">
                                  <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                                  <p>
                                    Overlaps {{ overlap.day }}'s hours, which run until
                                    {{ overlap.until }}. Start after {{ overlap.until }}.
                                  </p>
                                </div>
                              }
                              @if (hasServingTimeOutsideRestaurantHoursError(day.key, hourIndex)) {
                                <div class="d-flex mt-2 errorText gap-2">
                                  <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                                  <p>This time slot must be within the restaurant's open hours.</p>
                                </div>
                              }
                              @if (hasServingTimeIncompleteError(day.key, hourIndex)) {
                                <div class="d-flex mt-2 errorText gap-2">
                                  <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                                  <p>Please select both a start time and an end time.</p>
                                </div>
                              }
                            }
                            <button
                              type="button"
                              class="serving-time-btn-add-hour"
                              [disabled]="!canAddServingTimeHour(day.key)"
                              [matTooltip]="
                                !canAddServingTimeHour(day.key)
                                  ? 'No time left within the restaurant\'s open hours for this day'
                                  : ''
                              "
                              (click)="addServingTimeHour(day.key)"
                            >
                              + Hours
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>

            <div class="card-form mt-4 w-85">
              <div class="d-flex w-100">
                <div class="flex-grow-1">
                  <div class="header-card">
                    <div class="title-description">
                      <div class="title-basic-details">Customization</div>
                      <div class="basic-description">
                        Provide choices customers can select (e.g., size, toppings, drink options).
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-2">
                  <button
                    class="btn btn-dark"
                    type="button"
                    (click)="openCustomizationDialog()"
                    [ngClass]="{ 'disabled-content': isNotFnfHardware }"
                  >
                    <i class="bx bx-plus"></i> Add New
                  </button>
                </div>
              </div>

              <div class="w-100" [ngClass]="{ 'disabled-content': isNotFnfHardware }">
                <ng-multiselect-dropdown
                  class="custome-ng-multiselect-dropdown"
                  [placeholder]="'Select Existing Customizations'"
                  [settings]="dropdownSettings"
                  [data]="dropdownList"
                  formControlName="selectedCustomizations"
                  (onSelect)="onItemSelect($event)"
                  (onSelectAll)="onSelectAll($event)"
                  (onDeSelect)="onItemDeSelect($event)"
                  (onDeSelectAll)="onDeSelectAll($event)"
                >
                </ng-multiselect-dropdown>
              </div>

              <div
                class="w-100"
                formArrayName="customization"
                [ngClass]="{ 'disabled-content': isNotFnfHardware }"
              >
                @for (
                  subCustomization of customization.controls;
                  track subCustomization;
                  let i = $index
                ) {
                  <div class="row w-100 m-0 p-0" [formGroupName]="i">
                    <div class="d-flex w-100 mt-2">
                      <div class="align-content-center">
                        <div class="icon-container">
                          <div class="drag-icon">
                            <i class="bx bx-grid-vertical bx-xs"></i>
                          </div>
                        </div>
                      </div>
                      <div class="align-content-center pl-4">
                        <div class="row">
                          <div class="rating-label">
                            {{ subCustomization.get('name')?.value }}:
                            @if (
                              isCustomizationHiddenFromCustomers(subCustomization.get('id')?.value)
                            ) {
                              <span class="customer-visibility hidden-from-customers">
                                <i class="bx bx-hide"></i> Hidden from customers
                              </span>
                            } @else {
                              <span
                                class="customer-visibility visible-to-customers"
                                title="Shown to customers"
                              >
                                <i class="bx bx-show"></i>
                              </span>
                            }
                          </div>
                        </div>
                        @if (
                          subCustomization.get('inputType')?.value == 'Single Selection' ||
                          subCustomization.get('inputType')?.value == 'Text Field'
                        ) {
                          <div class="d-flex flex-wrap" formArrayName="options">
                            @for (
                              option of getCustomizationOption(subCustomization).controls;
                              track option;
                              let j = $index
                            ) {
                              @if (option.get('name')?.value) {
                                <div class="" [formGroupName]="j">
                                  <input
                                    type="radio"
                                    class="btn-check"
                                    [disabled]="!subCustomization.get('isEditable')?.value"
                                    [name]="subCustomization.get('name')?.value"
                                    [id]="option.get('name')?.value"
                                    [value]="option.get('name')?.value"
                                    [checked]="option.get('isChecked')?.value"
                                    (click)="
                                      onSingleCustomizationChange(
                                        $event,
                                        subCustomization,
                                        option,
                                        i,
                                        j
                                      )
                                    "
                                    autocomplete="off"
                                  />
                                  <label
                                    class="btn btn-light m-2"
                                    [for]="option.get('name')?.value"
                                  >
                                    @if (subCustomization.get('name')?.value == 'Spicy Level') {
                                      @for (
                                        spicy of getSpicy(option.get('name')?.value);
                                        track spicy;
                                        let z = $index
                                      ) {
                                        <svg
                                          class="icon-danger"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="17"
                                          height="16"
                                          viewBox="0 0 17 16"
                                          fill="none"
                                        >
                                          <path
                                            d="M13.5479 0.587892C13.8877 0.400392 14.3154 0.520509 14.5029 0.860353L14.6436 1.11524C15.209 2.13184 15.2236 3.33301 14.7432 4.33789C15.5254 5.17578 16 6.29785 16 7.53125C16 8.07324 15.9092 8.59473 15.7393 9.07813C15.5605 9.58496 14.9043 9.55567 14.6611 9.0752L14.3184 8.38965C14.1982 8.15235 13.9551 8 13.6885 8H11.5469C11.1572 8 10.8438 7.68653 10.8438 7.29688V4.95313C10.8438 4.56348 10.5303 4.25 10.1406 4.25H9.63965C9.01562 4.25 8.76074 3.54981 9.32324 3.28613C9.92676 3.00195 10.6006 2.84375 11.3125 2.84375C12.1416 2.84375 12.918 3.05762 13.5918 3.43555C13.7529 2.90235 13.7002 2.31055 13.416 1.80078L13.2754 1.5459C13.0879 1.20606 13.208 0.778322 13.5479 0.590822V0.587892ZM6.01562 10.6221L8.73438 5.1875H9.90625V7.53125C9.90625 8.30762 10.5361 8.9375 11.3125 8.9375H13.5449L14.2451 10.3379C11.9072 13.5049 8.15723 15.5 4.02344 15.5H2.30078C1.58301 15.5 1 14.917 1 14.1992C1 13.5898 1.4248 13.0625 2.01953 12.9307L3.47852 12.6055C4.58008 12.3594 5.51465 11.6328 6.01855 10.6221H6.01562Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      }
                                    }
                                    {{ option.get('name')?.value }}
                                  </label>
                                </div>
                              }
                            }
                          </div>
                        } @else if (subCustomization.get('inputType')?.value == 'Multi Selection') {
                          <div class="d-flex flex-wrap" formArrayName="options">
                            @for (
                              option of getCustomizationOption(subCustomization).controls;
                              track option;
                              let j = $index
                            ) {
                              @if (option.get('name')?.value) {
                                <div class="" [formGroupName]="j">
                                  <input
                                    type="checkbox"
                                    class="btn-check"
                                    [disabled]="!subCustomization.get('isEditable')?.value"
                                    [name]="subCustomization.get('name')?.value"
                                    [id]="option.get('name')?.value"
                                    [value]="option.get('name')?.value"
                                    [checked]="option.get('isChecked')?.value"
                                    (click)="
                                      onMultipleCustomizationChange(
                                        $event,
                                        subCustomization,
                                        option,
                                        i,
                                        j
                                      )
                                    "
                                    autocomplete="off"
                                  />
                                  <label
                                    class="btn btn-light m-2"
                                    [for]="option.get('name')?.value"
                                  >
                                    @if (subCustomization.get('name')?.value == 'Spicy Level') {
                                      @for (
                                        spicy of getSpicy(option.get('name')?.value);
                                        track spicy;
                                        let z = $index
                                      ) {
                                        <svg
                                          class="icon-danger"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="17"
                                          height="16"
                                          viewBox="0 0 17 16"
                                          fill="none"
                                        >
                                          <path
                                            d="M13.5479 0.587892C13.8877 0.400392 14.3154 0.520509 14.5029 0.860353L14.6436 1.11524C15.209 2.13184 15.2236 3.33301 14.7432 4.33789C15.5254 5.17578 16 6.29785 16 7.53125C16 8.07324 15.9092 8.59473 15.7393 9.07813C15.5605 9.58496 14.9043 9.55567 14.6611 9.0752L14.3184 8.38965C14.1982 8.15235 13.9551 8 13.6885 8H11.5469C11.1572 8 10.8438 7.68653 10.8438 7.29688V4.95313C10.8438 4.56348 10.5303 4.25 10.1406 4.25H9.63965C9.01562 4.25 8.76074 3.54981 9.32324 3.28613C9.92676 3.00195 10.6006 2.84375 11.3125 2.84375C12.1416 2.84375 12.918 3.05762 13.5918 3.43555C13.7529 2.90235 13.7002 2.31055 13.416 1.80078L13.2754 1.5459C13.0879 1.20606 13.208 0.778322 13.5479 0.590822V0.587892ZM6.01562 10.6221L8.73438 5.1875H9.90625V7.53125C9.90625 8.30762 10.5361 8.9375 11.3125 8.9375H13.5449L14.2451 10.3379C11.9072 13.5049 8.15723 15.5 4.02344 15.5H2.30078C1.58301 15.5 1 14.917 1 14.1992C1 13.5898 1.4248 13.0625 2.01953 12.9307L3.47852 12.6055C4.58008 12.3594 5.51465 11.6328 6.01855 10.6221H6.01562Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      }
                                    }
                                    {{ option.get('name')?.value }}
                                  </label>
                                </div>
                              }
                            }
                          </div>
                        }
                      </div>
                      <div class="ms-auto align-content-center">
                        <div
                          class="button-container"
                          (click)="removeCustomization(i, subCustomization.get('name')?.value)"
                        >
                          <div class="delete-icon-container">
                            <div class="delete-icon">
                              <i class="bx bx-trash text-danger p-1"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center w-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="601"
                      height="2"
                      viewBox="0 0 601 2"
                      fill="none"
                    >
                      <path
                        d="M0.5 1H600.5"
                        stroke="#D7DAE0"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-dasharray="2 4"
                      />
                    </svg>
                  </div>
                }
              </div>
            </div>

            <div class="card-form mt-4 w-85">
              <div class="d-flex w-100">
                <div class="flex-grow-1">
                  <div class="header-card">
                    <div class="title-description">
                      <div class="title-basic-details">Default Characteristics</div>
                      <div class="basic-description">
                        Provide preset characteristics that are not customizable.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-2">
                  <button
                    class="btn btn-dark"
                    type="button"
                    (click)="openCharacteristicsDialog()"
                    [ngClass]="{ 'disabled-content': isNotFnfHardware }"
                  >
                    <i class="bx bx-plus"></i> Add New
                  </button>
                </div>
              </div>

              @for (
                characteristic of productForm.get('characteristics')?.value;
                track characteristic;
                let idx = $index
              ) {
                <div class="row w-100 m-0 p-0">
                  <div class="rating-row">
                    <div class="icon-container">
                      <div class="drag-icon">
                        <i class="bx bx-grid-vertical bx-xs"></i>
                      </div>
                    </div>
                    <div class="label-container">
                      <div class="rating-label">{{ characteristic.name }}:</div>
                    </div>
                    <div class="value-container">
                      <div class="rating-value">{{ characteristic.value }}</div>
                    </div>
                    <div
                      class="button-container-warning border"
                      (click)="openCharacteristicsDialog(characteristic)"
                    >
                      <div class="delete-icon-container">
                        <div class="delete-icon">
                          <i class="bx bx-edit text-dark p-1"></i>
                        </div>
                      </div>
                    </div>
                    <div class="button-container" (click)="removeCharacteristic(idx)">
                      <div class="delete-icon-container">
                        <div class="delete-icon">
                          <i class="bx bx-trash text-danger p-1"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-center w-100">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="601"
                    height="2"
                    viewBox="0 0 601 2"
                    fill="none"
                  >
                    <path
                      d="M0.5 1H600.5"
                      stroke="#D7DAE0"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-dasharray="2 4"
                    />
                  </svg>
                </div>
              }
            </div>

            <div class="card-form mt-4 mb-3 w-85">
              <div class="header-card">
                <div class="title-description">
                  <div class="title-basic-details">Tags &amp; Additional Notes</div>
                  <div class="basic-description">
                    Add relevant tags and extra details for the item.
                  </div>
                </div>
              </div>
              <div class="row w-100 m-0 p-0 mt-1">
                <div class="d-flex m-0 p-0">
                  <div class="flex-grow-1">
                    <label class="form-label pl-0 pt-2">Tags:</label>
                  </div>
                  <div
                    class="p-2"
                    matTooltip="Before click It enter the Menu name."
                    matTooltipPosition="right"
                  >
                    <app-ai-generate-button
                      [loading]="generating.tags"
                      [disabled]="!productForm.get('name')?.value?.trim()"
                      (generate)="getMenuTags()"
                    ></app-ai-generate-button>
                  </div>
                </div>
                <div class="w-100 p-0">
                  <div class="ingredients-input-group">
                    @for (tag of tagsList; track tag; let idx = $index) {
                      <div class="ingredient-tag">
                        {{ tag | titlecase }}
                        <button type="button" class="remove-btn" (click)="removeTag(idx)">×</button>
                      </div>
                    }
                    <input
                      id="ingredient-input"
                      type="text"
                      class="ingredient-input"
                      formControlName="tagName"
                      placeholder="Enter Tags.."
                      (keydown.enter)="addNewTag()"
                    />
                  </div>
                </div>

                @if (productForm.get('tagName')?.touched && tagsList.length < 1 && false) {
                  <div class="d-flex mt-2 errorText gap-2 pl-0">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>This field cannot be empty.</p>
                  </div>
                } @else if (tagsList.length > 12) {
                  <div class="d-flex mt-2 errorText gap-2">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>Exceed the tags count limit.</p>
                  </div>
                }

                <div class="info-panel pl-0 mt-2 pr-0">
                  <div class="help-text">
                    Help customers find this item by adding relevant tags.
                  </div>
                  <div class="counter">
                    <span>
                      <span class="counter-start">{{ tagsList.length }}</span>
                      <span class="counter-end">/12</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row w-100 m-0 p-0">
                <label class="form-label pl-0">Additional Notes (Optional):</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="additionalNotes"
                  maxlength="200"
                />
                <div class="info-panel pl-0 mt-2 pr-0">
                  <div class="help-text">Add any extra information.</div>
                  <div class="counter">
                    <span>
                      <span class="counter-start">
                        {{ productForm.get('additionalNotes')?.value.length }}
                      </span>
                      <span class="counter-end">/200</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-sm-3 right-content am-col pl-0 pr-0">
      <div class="d-flex align-items-start flex-column am-col-inner">
        <div class="mb-auto p-3 w-100 overflow-y-auto">
          <div class="overlay w-100 text-center">
            @if (this.productForm.get('image_url')?.value) {
              <img
                [class]="
                  hasImageError(this.productForm.get('image_url')?.value) ? 'image-error' : ''
                "
                [src]="this.productForm.get('image_url')?.value"
                (error)="
                  onMenuThumbnailImageError($event, this.productForm.get('image_url')?.value)
                "
                class="object-fit-cover border-0 rounded-3 preview-image"
              />
            } @else {
              <span class="preview-empty" aria-hidden="true">
                <i class="bx bx-image"></i>
              </span>
            }
          </div>
          <div class="slider mt-2 d-flex flex-wrap justify-content-around">
            @if (productForm.get('additional_images')?.value[0]) {
              <img
                [class]="
                  hasImageError(productForm.get('additional_images')?.value[0]) ? 'image-error' : ''
                "
                [src]="productForm.get('additional_images')?.value[0]"
                class="thumb-img"
                style="width: 60px"
                (error)="
                  onMenuThumbnailImageError($event, productForm.get('additional_images')?.value[0])
                "
              />
            } @else {
              <span class="thumb-empty" aria-hidden="true">
                <i class="bx bx-image"></i>
              </span>
            }
            @if (productForm.get('additional_images')?.value[1]) {
              <img
                [class]="
                  hasImageError(productForm.get('additional_images')?.value[1]) ? 'image-error' : ''
                "
                [src]="productForm.get('additional_images')?.value[1]"
                class="thumb-img"
                style="width: 60px"
                (error)="
                  onMenuThumbnailImageError($event, productForm.get('additional_images')?.value[1])
                "
              />
            } @else {
              <span class="thumb-empty" aria-hidden="true">
                <i class="bx bx-image"></i>
              </span>
            }
            @if (productForm.get('additional_images')?.value[2]) {
              <img
                [class]="
                  hasImageError(productForm.get('additional_images')?.value[2]) ? 'image-error' : ''
                "
                [src]="productForm.get('additional_images')?.value[2]"
                class="thumb-img"
                style="width: 60px"
                (error)="
                  onMenuThumbnailImageError($event, productForm.get('additional_images')?.value[2])
                "
              />
            } @else {
              <span class="thumb-empty" aria-hidden="true">
                <i class="bx bx-image"></i>
              </span>
            }
            @if (productForm.get('additional_images')?.value[3]) {
              <img
                [class]="
                  hasImageError(productForm.get('additional_images')?.value[3]) ? 'image-error' : ''
                "
                [src]="productForm.get('additional_images')?.value[3]"
                class="thumb-img"
                style="width: 60px"
                (error)="
                  onMenuThumbnailImageError($event, productForm.get('additional_images')?.value[3])
                "
              />
            } @else {
              <span class="thumb-empty" aria-hidden="true">
                <i class="bx bx-image"></i>
              </span>
            }
          </div>

          <div class="row p-0 m-0 mt-3">
            <div class="fnf-label pl-0">Name:</div>
            <div class="fnf-answer-label pl-0 text-break">
              {{ productForm.get('name')?.value ? productForm.get('name')?.value : '-' }}
            </div>
          </div>

          <div class="row m-0 p-0 mt-3">
            <div class="fnf-label pl-0">Description:</div>
            <div class="fnf-answer-label pl-0 text-break">
              {{
                productForm.get('description')?.value ? productForm.get('description')?.value : '-'
              }}
            </div>
          </div>

          <div class="row m-0 p-0 mt-3">
            <div class="custom-line"></div>
          </div>

          <div class="row p-0 m-0 mt-3">
            <div class="col-6 p-0">
              <div class="fnf-label pl-0">Price:</div>
              <div class="fnf-answer-label pl-0">
                $ {{ productForm.get('originalPrice')?.value | number: '1.2-2' }}
              </div>
            </div>
          </div>

          <div class="row p-0 m-0 mt-3">
            <div class="col-6 p-0">
              <div class="fnf-label pl-0">SKU:</div>
              <div class="fnf-answer-label pl-0">
                {{ productForm.get('sku')?.value ? productForm.get('sku')?.value : '-' }}
              </div>
            </div>
            <div class="col-6 p-0">
              <div class="fnf-label pl-0">Stock:</div>
              <div class="fnf-answer-label pl-0">
                {{ productForm.get('stockStatus')?.value ? 'In-stock' : 'Out of stock' }}
              </div>
            </div>
          </div>
          @if (getTypes().length > 0) {
            <div class="row m-0 p-0 mt-3">
              <div class="custom-line"></div>
            </div>
          }
          @if (classification && classification.value.length > 0) {
            @for (
              subClassification of classification.value;
              track subClassification;
              let idx = $index
            ) {
              <div class="row p-0 m-0 mt-3">
                <div class="fnf-label pl-0">{{ subClassification?.name }}:</div>
                <div class="fnf-answer-label flex-wrap pl-0">
                  @for (option of subClassification.options; track option; let idx = $index) {
                    @if (option.isChecked) {
                      <!-- <div class="fnf-answer-label flex-wrap pl-0"> -->
                      <li class="pe-2 ml-3">{{ option.name }}</li>
                      <!-- </div> -->
                    }
                  }
                </div>
              </div>
            }
          }

          @if (getCustomizations().length > 0) {
            <div class="row m-0 p-0 mt-3">
              <div class="custom-line"></div>
            </div>
          }
          @if (getCustomizations().length > 0) {
            @for (customization1 of customization.value; track customization1; let idx = $index) {
              <div class="row p-0 m-0 mt-3">
                <div class="fnf-label pl-0">
                  {{ customization1?.name }}:
                  @if (isCustomizationHiddenFromCustomers(customization1?.id)) {
                    <span class="customer-visibility hidden-from-customers">
                      <i class="bx bx-hide"></i> Hidden from customers
                    </span>
                  } @else {
                    <span
                      class="customer-visibility visible-to-customers"
                      title="Shown to customers"
                    >
                      <i class="bx bx-show"></i>
                    </span>
                  }
                </div>
                @for (option of customization1.options; track option; let idx = $index) {
                  @if (option.isChecked) {
                    <div class="fnf-answer-label flex-wrap pl-0">
                      <li class="pe-2 ml-3">{{ option.name }}</li>
                    </div>
                  }
                }
              </div>
            }
          }

          @if (getCharacteristicsArray().length > 0) {
            <div class="row m-0 p-0 mt-3">
              <div class="custom-line"></div>
            </div>
          }
          <div class="row p-0 m-0 mt-2"></div>
          @for (
            characteristic1 of productForm.get('characteristics')?.value;
            track characteristic1;
            let idx = $index
          ) {
            <div class="row p-0 m-0 mt-1">
              <div class="fnf-label pl-0">{{ characteristic1?.name }}:</div>
              <div class="fnf-answer-label pl-0">
                {{ characteristic1.value }}
              </div>
            </div>
          }
          <div class="row m-0 p-0 mt-3">
            <div class="custom-line"></div>
          </div>

          <div class="row p-0 m-0 mt-3">
            <div class="fnf-label pl-0">Ingredients:</div>
            <div class="fnf-answer-label flex-wrap pl-0">
              @if (getIngredients().length == 0) {
                -
              }
              @for (ingredient of getIngredients(); track ingredient; let idx = $index) {
                <li class="pe-2 ml-3">{{ ingredient | titlecase }}</li>
              }
            </div>
          </div>

          <div class="row p-0 m-0 mt-3">
            <div class="col-6 p-0">
              <div class="fnf-label pl-0">Preparation Time:</div>
              <div class="fnf-answer-label pl-0">
                {{
                  productForm.get('preparationTime')?.value
                    ? productForm.get('preparationTime')?.value
                    : '-'
                }}
                Minutes
              </div>
            </div>
            <div class="col-6 p-0">
              <div class="fnf-label pl-0">Serving Size:</div>
              <div class="fnf-answer-label pl-0">
                {{
                  productForm.get('servingSize')?.value
                    ? productForm.get('servingSize')?.value
                    : '-'
                }}
                Servers
              </div>
            </div>
          </div>

          <div class="row m-0 p-0 mt-3">
            <div class="custom-line"></div>
          </div>

          <div class="row p-0 m-0 mt-3">
            <div class="fnf-label pl-0">Tags:</div>
            <div class="fnf-answer-label flex-wrap pl-0">
              @if (getTags().length == 0) {
                -
              }
              @for (tag of getTags(); track tag; let idx = $index) {
                <li class="pe-2 ml-3">{{ tag | titlecase }}</li>
              }
            </div>
          </div>

          <div class="row p-0 m-0 mt-3 mb-4">
            <div class="fnf-label pl-0">Additional Notes:</div>
            <div class="fnf-answer-label pl-0">
              {{
                productForm.get('additionalNotes')?.value
                  ? productForm.get('additionalNotes')?.value
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="p-2 w-100 mb-0 p-3 add-btn-content">
          @if (
            isSubmit &&
            selectedStatus == 'draft' &&
            (productForm.get('name')?.value == '' || !isAnyCategorySelected)
          ) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Name and Category fields can not empty !</p>
            </div>
          }

          @if (isSubmit && productForm.invalid && selectedStatus == 'published') {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Enter the all mandatory fields !</p>
            </div>
          } @else if (
            isSubmit && productForm.valid && !isAnyCategorySelected && selectedStatus == 'published'
          ) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Select at least one category from any type !</p>
            </div>
          }

          <div class="d-flex mb-3">
            <div class="p-2 flex-grow-1">Status</div>
            @if (productForm.get('status')?.value == 'draft') {
              <div class="p-2 bg-warning-subtle pl-3 pr-3 rounded-2">
                {{ productForm.get('status')?.value | titlecase }}
              </div>
            }
            @if (productForm.get('status')?.value == 'published') {
              <div class="p-2 bg-success-subtle pl-3 pr-3 rounded-3">
                {{ productForm.get('status')?.value | titlecase }}
              </div>
            }
          </div>

          <div class="custom-line mb-3"></div>

          <div class="btn-group btn-block btn-group-md" role="group">
            <button
              type="button"
              class="btn btn-light rounded-3 p-2 w-50 mr-2"
              (click)="draftMenu()"
              [ngClass]="{ 'disabled-content': isNotFnfHardware }"
            >
              Save As Draft
            </button>
            <button
              type="button"
              class="btn btn-dark ms-2 rounded-3 p-2 w-50"
              (click)="publishedMenu()"
            >
              Publish
            </button>
          </div>

          <div class="btn-group btn-block btn-group-md mt-3" role="group">
            <button
              type="button"
              class="btn btn-white border rounded-3 p-2 w-50 text-black-50 bg-white"
              (click)="cancelMenu()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
